import {init} from '@sentry/browser'

if (process.env.NODE_ENV === 'production') {
  const dsn = 'https://3b055291a1e140d89052505d3982f1f2@sentry.kensho.com/97'
  init({dsn})
}
